import StatisticsApi from "../api/statistics";
import { BaseActions } from "./BaseActions";
import ReduxTypes from "../consts/ReduxTypes";

export default new (class StatisticsActions extends BaseActions {
  constructor() {
    super(StatisticsApi, "STATISTICS");
  }

  fetchStats = (callback?: any) => {
    return (dispatch: any) => {
      dispatch({ type: ReduxTypes.FETCH_STATISTICS_START });
      StatisticsApi.fetchStats()
        .then((res: any) => {
          dispatch({ type: ReduxTypes.FETCH_STATISTICS_SUCCESS, payload: res.data });
          if (callback) callback(null, res.data);
        })
        .catch((err: any) => {
          dispatch({ type: ReduxTypes.FETCH_STATISTICS_ERROR, error: err });
          if (callback) callback(err);
        });
    };
  };

  downloadStatsCsv = (callback?: any) => {
    return (dispatch: any) => {
      dispatch({ type: ReduxTypes.DOWNLOAD_STATISTICS_CSV_START });
      StatisticsApi.fetchStatsCsv()
        .then((res: any) => {
          dispatch({ type: ReduxTypes.DOWNLOAD_STATISTICS_CSV_SUCCESS, payload: res.data });
          if (callback) callback(null, res.data);
        })
        .catch((err: any) => {
          dispatch({ type: ReduxTypes.DOWNLOAD_STATISTICS_CSV_ERROR, error: err });
          if (callback) callback(err);
        });
    };
  };
})();
